import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Footer from '../../components/Footer/Footer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import { TwitterTimelineEmbed } from 'react-twitter-embed';
import { Timeline } from 'react-twitter-widgets';
import { managed_contents, HeaderConfig } from "Api/Api";
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import axios from "axios";
import home from 'Assets/home.svg';

import UserContext from 'store/UserContext';

//import { ReactTypeformEmbed } from 'react-typeform-embed';

import HubspotForm from 'react-hubspot-form'

class AboutPage extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            about_res: '',
            press_res: '',
            about_data: '',
            about_data1: '',
            about_data2: '',
            press_data_obj: {},
            loading: true,
        };
    }
    // About page API Func
    componentDidMount() {
        function About() {
            return axios.get(`${managed_contents}/about`, HeaderConfig);
        }
        // Press API Func
        function Press() {
            return axios.get(`${managed_contents}/press`, HeaderConfig);
        }
        // Calling all API's using axios.all method
        axios.all([About(), Press()])
            .then(axios.spread((about_res, press_res) => {

                let tmp_press_data_obj = {};
                for (let content_section_name of Object.keys(press_res.data.content_sections)) {
                    if (content_section_name.startsWith('press_section_')) {
                        tmp_press_data_obj[content_section_name] = press_res.data.content_sections[content_section_name];
                    }
                }

                this.setState({
                    // upper left content section data
                    about_data: about_res.data.content_sections.upper_left_1,
                    about_data1: about_res.data.content_sections.upper_left_2,
                    about_data2: about_res.data.content_sections.upper_left_3,
                    // press content api data 
                    press_data_obj: tmp_press_data_obj,
                    loading: false,
                });
            }))
            .catch(() => {
                this.setState({ ModalLoader: false })
            });
    };
    ContactUs = () => {
        this.props.history.push("/contactus");
    }

    render() {

        if (this.state.loading) {
            return (
                <ActivityIndicator theme="spinner" />
            )
        }
        else {
            const { about_data, about_data1, about_data2 } = this.state;
            return (
                <React.Fragment>
                <Helmet defer={false}>
                    <title>About PechaKucha</title>
                    <meta name="description" content="PechaKucha (Japanese for 'chit chat') is the world's fastest-growing storytelling platform, used by millions around the globe." />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.pechakucha.com/about" />
                    <meta property="og:title" content="About PechaKucha" />
                    <meta property="og:description" content="PechaKucha (Japanese for 'chit chat') is the world's fastest-growing storytelling platform, used by millions around the globe." />
                </Helmet>
                <div>
                    <div className="About-page">
                        <div className="container">
                            <div>
                                <Row>
                                    <Col lg={7}>
                                        <div className="aboutPechaKucha">
                                            <div className="about">
                                                <div className="pechaKuchaData">
                                                    <h3>{about_data.title}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: about_data.html_content }} />
                                                </div>
                                                <div className="pechaKuchaData">
                                                    <h3>{about_data1.title}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: about_data1.html_content }} />
                                                </div>
                                                <div className="pechaKuchaData">
                                                    <h3>{about_data2.title}</h3>
                                                    <p dangerouslySetInnerHTML={{ __html: about_data2.html_content }} />
                                                </div>
                                            </div>
                                            {/*
                                            <hr />
                                            <div className="pechaKuchaData aboutPress">
                                                <h3>Press</h3>
                                                {Object.values(press_data_obj).map(item => (
                                                    <div className="pressContent">
                                                        <h4>{item.title} / {item.greeting}</h4>
                                                        <a href={item.link_url}>{item.link_text}</a>
                                                    </div>
                                                ))}
                                            </div>
                                            */}
                                            {/*
                                            <div className="additionalQue">
                                                <h4>Have an Additional Questions, or just want to say hello?</h4>
                                                <a href="mailto:support@pechakucha.org">
                                                    <Button theme="btn-global btn-green btn-favorite btn-about-contact">Contact Us</Button>
                                                </a>
                                            </div>
                                            */}
                                                            {/* Form Section */}
                                                            {/*<ReactTypeformEmbed url="https://pechakucha.typeform.com/to/qMv7Rv" /> */}
                                            {/*
                                            <section>
                                                <div className="container">
                                                    <Row>
                                                        <Col lg={12}>
                                                            <div className="form-head">
                                                                <h1 style={{ paddingBottom: "0px" }}>Looking to connect with us? Please fill out this form and we’ll get back to you!</h1>
                                                            </div>
                                                        </Col>
                                                        <Col lg={12}>
                                                            <div>
                                               
                                                                <div style={{ backgroundColor: "lightgray", marginTop: "10px", padding: "15px" }}>
                                                                    <HubspotForm
                                                                       portalId='6817434'
                                                                       formId='22e00593-4dfd-4cef-bbfb-ffafddf51ef6'
                                                                       //onSubmit={() => console.log('Submit!')}
                                                                       //onReady={(form) => console.log('Form ready!')}
                                                                       //loading={<div>Loading...</div>}
                                                                      />
                                                                    
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </section>
                                            */}
                                            
                                            
                                        </div>
                                    </Col>
                                    <Col lg={5}>
                                        <div>
                                            <Timeline
                                                dataSource={{
                                                  sourceType: 'profile',
                                                  screenName: 'PechaKucha'
                                                }}
                                                options={{
                                                  chrome: 'noscrollbar noborders noheader nofooter',
                                                  //height: '309',
                                                  tweetLimit: 3,
                                                  theme: this.context.theme
                                                }}
                                            />
                                            <br/>
                                            
                                            {/*
                                            <TwitterTimelineEmbed
                                                sourceType="profile"
                                                screenName="PechaKucha"
                                                data-tweet-limit="3"
                                                options={{ theme: this.context.theme, tweetLimit: '3' }}
                                            />
                                            */}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                    <Footer
                        homeImg={home}
                        homeImgRef="/"
                        breadcrumbSubPage="About" />
                </div>
                </React.Fragment>
            );
        }
    }
}

export default AboutPage;

//
/*
like this
*/

